/*
 * @Author: YH000644 weirongwei@danghuan.com
 * @Date: 2024-12-03 12:07:13
 * @LastEditors: YH000644 weirongwei@danghuan.com
 * @LastEditTime: 2024-12-10 11:20:11
 * @FilePath: \eu-eswop-official-site\src\main.js
 * @Description:
 */
import 'swiper/swiper.min.css'
import './assets/css/font.css'
import 'element-ui/lib/theme-chalk/index.css';

import ElementUI from 'element-ui';
import {
  Button,
  Dialog,
  Field,
  Icon,
  Image,
  ImagePreview,
  Lazyload,
  List,
  Loading,
  Overlay,
  Popup,
  PullRefresh,
  Skeleton,
  Step,
  Steps,
  Toast,
  Uploader} from 'vant'
import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueClipboard from 'vue-clipboard2';

import App from './App.vue'
import {i18n} from './locales'
import router from './router'
import store from './store'
import resize from './utils/resize'
import { isOpenInWebview,isPC } from './utils/util.js';


Vue.use(VueClipboard);

import 'lib-flexible'
Vue.config.productionTip = false
resize(document, window)
Vue.use(VueAwesomeSwiper)

Vue.use(ElementUI);
if (isPC()) {
  // PC 端不使用 Vant 组件
} else {
  Vue.use(Step)
  Vue.use(Icon)
  Vue.use(Steps)
  Vue.use(Uploader)
  Vue.use(Button)
  Vue.use(Toast)
  Vue.use(Dialog)
  Vue.use(Lazyload)
  Vue.use(Loading)
  Vue.use(List)
  Vue.use(PullRefresh)
  Vue.use(Skeleton)
  Vue.use(Popup)
  Vue.use(ImagePreview)
  Vue.use(Overlay)
  Vue.use(Image)
  Vue.use(Field)
}

Vue.prototype.$isOpenInWebview = isOpenInWebview();

router.beforeEach((to, from, next) => {
  // 在每次路由改变前将滚动条置顶
  window.scrollTo(0, 0);
  next();
});

// 初始化sensors
// initSensorsData()
new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
